import { RouteObject } from "react-router-dom"
import Worktime from "./_list"
import WorktimeDetail from "./_detail"
import WorktimeLeadList from "./lead/list"
import WorktimeDailyList from "./daily/list"
import WorktimeLeadDetail from "./lead/detail"
import WorktimeDailyDetail from "./daily/detail"
import WorktimeDailyAudit from "./daily/audit"
import WorktimeDailyAuditInfo from "./daily/auditInfo"
import { PpmLayout } from "../layouts"

// const worktimeRoute: RouteObject = {
//   path: "worktime",
//   element: <PpmLayout />,
//   children: [
//     {
//       index: true,
//       element: <Worktime />,
//     },
//     {
//       path: ":memberID",
//       element: <WorktimeDetail />,
//     },
//   ],
// }

//@deprecated 老版本
// const worktimeLeadRoute: RouteObject = {
//   path: "worktime-lead",
//   element: <PpmLayout />,
//   children: [
//     {
//       index: true,
//       element: <WorktimeLeadList />,
//     },
//     {
//       path: ":memberID",
//       element: <WorktimeLeadDetail />,
//     },
//   ],
// }

const worktimeDailyRoute: RouteObject = {
  path: "worktime",
  element: <PpmLayout />,
  children: [
    {
      index: true,
      element: <WorktimeDailyAudit />,
      // element: <WorktimeDailyList />,
    },
    {
      path: "audit",
      element: <WorktimeDailyAudit />,
    },
    // {
    //   path: "audit-info",
    //   element: <WorktimeDailyAuditInfo />,
    // },
    {
      path: "users/:userID/currentDate/:currentDate",
      element: <WorktimeDailyDetail />,
    },
  ],
}

export { worktimeDailyRoute }
